export const handleAddressSelect = (address, geocodeByAddress, getLatLng) => {
  geocodeByAddress(address).then((results) => getLatLng(results[0]));
  // .then((latLng) => setProceed(true));
  //   .then(latLng => console.log('Success', latLng))
  //   .catch(error => console.error('Error', error));
};
